module.exports = __webpack_public_path__ + "static/img/logo.25a7792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/comment/logo.png
// module id = agyG
// module chunks = 11